import { c as _c } from "react/compiler-runtime";
import { SkeletonPulse } from '@/components/Atoms/SkeletonPulse/SkeletonPulse';
import skeletonStyles from '@/components/Atoms/SkeletonPulse/SkeletonPulse.module.css';
import classNames from '@/utils/classNames';
import type { FCl } from 'react-fc';
import styles from './SkeletonCard.module.css';
export const SkeletonCard: FCl<{
  withImage?: boolean;
}> = t0 => {
  const $ = _c(15);
  const {
    withImage: t1,
    className
  } = t0;
  const withImage = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== className) {
    t2 = classNames(styles.container, className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== withImage) {
    t3 = classNames(styles.grid, {
      [styles.imageGrid]: withImage
    });
    $[2] = withImage;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={classNames(skeletonStyles.SkeletonPulse, styles.tag)} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SkeletonPulse lines={2} className={classNames(styles.title)} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== withImage) {
    t6 = withImage && <div className={classNames(skeletonStyles.SkeletonPulse, styles.image)} />;
    $[6] = withImage;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className={classNames(skeletonStyles.SkeletonPulse, styles.meta)} />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t3 || $[10] !== t6) {
    t8 = <div className={t3}>{t4}{t5}{t6}{t7}</div>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t8) {
    t9 = <div className={t2}>{t8}</div>;
    $[12] = t2;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};